import script from "./profile.vue?vue&type=script&setup=true&lang=js"
export * from "./profile.vue?vue&type=script&setup=true&lang=js"

import "./profile.vue?vue&type=style&index=0&id=1f53ee9d&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f53ee9d"]])

export default __exports__